export const Mutation = {
    CREATE_COLLAPSE_STATE: 'CREATE_COLLAPSE_STATE',
    UPDATE_COLLAPSE_STATE: 'UPDATE_COLLAPSE_STATE',
    DELETE_COLLAPSE_STATE: 'DELETE_COLLAPSE_STATE',
    CLOSE_COLLAPSE_STATES: 'CLOSE_COLLAPSE_STATES',

    CREATE_ROW: 'CREATE_ROW',
    UPDATE_ROW: 'UPDATE_ROW',
    DELETE_ROW: 'DELETE_ROW',
    DELETE_ALL_ROWS: 'DELETE_ALL_ROWS',
}
